import { FC } from "react";
import BlurHashAvatar from "./BlurHashAvatar";

interface CardProps {
  name: string;
  description: string;
  dateTime: string;
  providerName: string;
  providerLogo: string;
  eventLink: string;
  country: string;
  region: string;
  onClick: () => void;
  providerLogoBlurHash: string;
}

const Card: FC<CardProps> = ({
  name,
  dateTime,
  providerName,
  providerLogo,
  country,
  region,
  onClick,
  providerLogoBlurHash,
}) => {
  return (
    <div
      onClick={onClick}
      className="bg-muted-lightGrey hover:bg-white transition-background duration-300 rounded-lg border bg-muted-grey border-muted-grey hover:shadow-[10px_10px_0_-2px_theme(colors.muted.grey)]  p-6 flex gap-4 max-w-2xl transition-shadow"
    >
      {/* Provider Logo */}
      <div className="flex-shrink-0 flex flex-col justify-between ">
        <div className="w-16 h-16 overflow-hidden rounded-lg">
          <BlurHashAvatar
            src={providerLogo}
            blurHash={providerLogoBlurHash}
            alt={`${providerName} logo`}
            roundedClassName="rounded-full"
            borderClassName="border-[5px] border-muted-sage"
            className="object-cover object-contain greyscale-[70%]"
          />
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 flex flex-col">
        <div>
          <h3 className="text-xl font-semibold text-gray-900 mb-1">{name}</h3>
          <h4 className="leading-[3]">{providerName}</h4>
          <h4 className="text-sm text-gray-600 mb-2">{dateTime}</h4>
        </div>

        <div className="mt-auto flex items-center justify-between">
          <div className="text-gray-600 hover:text-gray-900">
            {country && region && (
              <span>
                {country}, {region}
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Card;
